import { getTypedState } from 'ducks/hooks'
import { Payment } from 'ducks/types'

export const getPayment = () => (): Payment => {
  const { payment } = getTypedState()
  return payment
}
